"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _ErrorApi = require("./../../../utils/ErrorApi");

var _ErrorApi2 = _interopRequireDefault(_ErrorApi);

var _Fetch = require("./../../../utils/Fetch");

var _Fetch2 = _interopRequireDefault(_Fetch);

var _ParamsFetch = require("./../../../utils/ParamsFetch");

var _ParamsFetch2 = _interopRequireDefault(_ParamsFetch);

var _JsonFetch = require("./../../../utils/JsonFetch");

var _JsonFetch2 = _interopRequireDefault(_JsonFetch);

var _generateUrl = require("./../../../utils/generateUrl");

var _generateUrl2 = _interopRequireDefault(_generateUrl);

var _UpdateMethods = require("./UpdateMethods");

var UpdateMethods = _interopRequireWildcard(_UpdateMethods);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Autofill Controller Uložení/Načtení předvyplnovaných dat Generated from cz.marbes.uzn.AutofillController.
 */
// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-01-07T17:41:17Z                      #

// ##############################################################

var AutofillApi = function () {
  function AutofillApi() {
    (0, _classCallCheck3.default)(this, AutofillApi);
  }

  (0, _createClass3.default)(AutofillApi, null, [{
    key: "save",

    /**
     * Uložení dat na server - cesta -> hodnota
     *
     * @param data Data k uložení
     */
    value: function save(data) {
      var uri = serverContextPath + "/api/autofill";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.put(uri, params, data, headers));
    }

    /**
     * Načtení dat pomocí cest ze stromu
     *
     * @param pathLists cesty
     * @return Mapa dat cest
     */

  }, {
    key: "load",
    value: function load(pathLists) {
      var uri = serverContextPath + "/api/autofill";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.post(uri, params, pathLists, headers));
    }
  }]);
  return AutofillApi;
}();

exports.default = AutofillApi;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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